/** Kleine Symbole der Gliederung (Binder): Buch, Ordner, Seite, Pfeil zum Auf- und Zuklappen. */
export type BinderIconKind = 'book' | 'section' | 'folder' | 'folder-open' | 'page' | 'page-text' | 'notes';

const PATHS: Record<BinderIconKind, string[]> = {
  book: ['M5 4.5A1.5 1.5 0 0 1 6.5 3H19v15H6.5A1.5 1.5 0 0 0 5 19.5v-15z', 'M5 19.5A1.5 1.5 0 0 0 6.5 21H19v-3', 'M9 7h6'],
  // Abschnitt: ein Stapel Ordner
  section: ['M3 10.5A1.5 1.5 0 0 1 4.5 9h15a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18.5z', 'M5 6h14', 'M7 3h10'],
  folder: ['M3 7.5A1.5 1.5 0 0 1 4.5 6h4l2 2h9A1.5 1.5 0 0 1 21 9.5v8a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5z'],
  'folder-open': ['M3 17.5V7.5A1.5 1.5 0 0 1 4.5 6h4l2 2h7A1.5 1.5 0 0 1 19 9.5V11', 'M3 17.5l2.4-5.6A1.5 1.5 0 0 1 6.8 11H21l-2.6 7a1.5 1.5 0 0 1-1.4 1H4.5A1.5 1.5 0 0 1 3 17.5z'],
  page: ['M7 3h7l4 4v12.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19.5v-15A1.5 1.5 0 0 1 7.5 3z', 'M14 3v4h4'],
  'page-text': ['M7 3h7l4 4v12.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19.5v-15A1.5 1.5 0 0 1 7.5 3z', 'M14 3v4h4', 'M9 11h6M9 14h6M9 17h4'],
  notes: ['M5 4h14v16H5z', 'M8 8h8M8 12h8M8 16h5'],
};

/** `folded`: Seite mit Eselsohr – das Dokument hat Versionen (wie in Scrivener) */
export function BinderIcon({ kind, color, folded }: { kind: BinderIconKind; color?: string; folded?: boolean }) {
  return (
    <svg className={`binder-icon icon-${kind}${folded ? ' folded' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color ?? 'currentColor'} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {PATHS[kind].map((d) => (
        <path key={d} d={d} />
      ))}
      {folded && <path d="M14 3v4h4z" fill={color ?? 'currentColor'} />}
    </svg>
  );
}

/** Pfeil zum Auf- und Zuklappen einer Gruppe */
export function Chevron({ open, onToggle, label }: { open: boolean; onToggle: () => void; label: string }) {
  return (
    <button type="button" className={`binder-chevron${open ? ' open' : ''}`} aria-expanded={open} aria-label={label} title={label} onClick={onToggle}>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M9 6l6 6-6 6" />
      </svg>
    </button>
  );
}
